import { Draw } from "ol/interaction";

import { Feature, Map } from "ol";
import VectorSource from "ol/source/Vector";
import { useEffect, useState } from "react";
import { DrawEvent } from "ol/interaction/Draw";

export function useDraw(
	map: Map | null,
	source: VectorSource,
	onUpdate: (features: Feature[]) => void,
) {
	const [draw] = useState(
		new Draw({
			source,
			type: "Polygon",
		}),
	);

	useEffect(() => {
		if (!map) return () => {};

		draw.setActive(false);

		const onDrawEnd = (e: DrawEvent) => {
			onUpdate([e.feature]);
		};

		draw.on("drawend", onDrawEnd);
		map.addInteraction(draw);

		return () => {
			map.removeInteraction(draw);
			draw.un("drawend", onDrawEnd);
		};
	}, [map, draw, onUpdate]);

	return draw;
}